import React, { useState, useEffect } from 'react';
import Icon from '../Icon';
import clsx from 'clsx';
import { translate } from '../../Services/translation';
import { add, remove } from '../../Services/WishList.service';
import { useDispatch, useSelector } from 'react-redux';

const WishListButton = ({ noBorder, articleId, quantity }) => {
  const dispatch = useDispatch();
  const wishList = useSelector((state) => state.wishList);
  const isInWishlist = Array.isArray(wishList?.items) && wishList.items.some(item => item.articleNumber === articleId);

  const addToWishList = () => {
    if (isInWishlist) {
      dispatch(remove(articleId, quantity));

      dataLayerRemoveFromFavourites(articleId, productName, productCategory); //tracking
    } else {
      dispatch(add(articleId));

      dataLayerAddToFavourites(articleId, productName, productCategory); //tracking
    }
  };

  return (
    <button
      className={clsx(
        'wish-list__button',
        noBorder && 'wish-list__button--no-border'
      )}
      onClick={addToWishList}
      aria-label={translate(isInWishlist ? 'wishlist.remove.sc' : 'wishlist.add.sc')}
    >
      <Icon
        name={isInWishlist ? 'Star-Filled' : 'Star'}
        size={24}
        className="wish-list__button-icon"
      />
    </button>
  );
};

export default WishListButton;
